import { Controller } from "@hotwired/stimulus"
import "@selectize/selectize"

export default class extends Controller {
  static targets = ["listSelection", "companyEntry", "submitButton", "bulkAlert", "searchAlert", "newListName"]
  static values = {
    searchUrl: String,
  }

  connect() {
    const checkbox = this.element.querySelector("#add-to-list-checkbox")
    if (checkbox) {
      this.toggleListSelectionBasedOnCheckbox(checkbox.checked)
    }

    this.initializeSelectize()

    this.updateSubmitButtonState()
    this.updateBulkAlertVisibility()

    document.addEventListener("turbo:render", this.handleTurboRender.bind(this))

    this.companiesListObserver = new MutationObserver(this.handleCompaniesListChange.bind(this))
    const companiesList = this.element.querySelector("#companiesList")
    if (companiesList) {
      this.companiesListObserver.observe(companiesList, {
        childList: true,
        subtree: true,
      })
    }
  }

  disconnect() {
    // Destroy Selectize instance to avoid duplication
    if (this.selectizeInstance && this.selectizeInstance[0] && this.selectizeInstance[0].selectize) {
      this.selectizeInstance[0].selectize.destroy()
    }

    if (this.companiesListObserver) {
      this.companiesListObserver.disconnect()
    }
    document.removeEventListener("turbo:render", this.handleTurboRender.bind(this))
  }

  initializeSelectize() {
    const selectElement = this.element.querySelector("#company-list-field")
    if (selectElement) {
      this.selectizeInstance = $(selectElement).selectize({
        onInitialize: function () {
          $(this.$wrapper)[0].style.visibility = "visible"
        },
        onChange: (value) => {
          if (value === "new_list") {
            if (this.hasNewListNameTarget) {
              this.newListNameTarget.classList.remove("d-none")
            }
          } else {
            if (this.hasNewListNameTarget) {
              this.newListNameTarget.classList.add("d-none")
            }
          }
        },
      })
    }
  }

  handleListSelection(event) {
    const value = event.target.value
    if (value === "new_list") {
      if (this.hasNewListNameTarget) {
        this.newListNameTarget.classList.remove("d-none")
      }
    } else {
      if (this.hasNewListNameTarget) {
        this.newListNameTarget.classList.add("d-none")
      }
    }
  }

  handleTurboRender() {
    setTimeout(() => {
      this.updateSubmitButtonState()
      this.updateBulkAlertVisibility()
    }, 50)
  }

  handleCompaniesListChange() {
    this.updateSubmitButtonState()
    this.updateBulkAlertVisibility()
  }

  toggleListSelection(event) {
    this.toggleListSelectionBasedOnCheckbox(event.target.checked)
  }

  toggleListSelectionBasedOnCheckbox(isChecked) {
    if (this.hasListSelectionTarget) {
      if (isChecked) {
        this.listSelectionTarget.classList.remove("d-none")
      } else {
        this.listSelectionTarget.classList.add("d-none")
      }
    }
  }

  search(event) {
    event.preventDefault()

    if (this.hasSearchAlertTarget) {
      this.searchAlertTarget.innerHTML = ""
    }

    const autocompleteInput = document.getElementById("new-account-autocomplete")
    const domain = autocompleteInput.value.trim().toLowerCase()

    if (!domain) {
      return
    }

    const existingDomains = Array.from(this.companyEntryTargets || []).map((entry) => {
      const hiddenInput = entry.querySelector('input[name="companies[]"]')
      return hiddenInput ? hiddenInput.value.toLowerCase() : ""
    })

    if (existingDomains.includes(domain)) {
      autocompleteInput.value = ""
      return
    }

    const originalInputValue = autocompleteInput.value

    const formData = new FormData()
    formData.append("domain", domain)

    fetch(this.searchUrlValue, {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        Accept: "text/vnd.turbo-stream.html, text/html, application/xhtml+xml",
      },
      body: formData,
    })
      .then((response) => response.text())
      .then((html) => {
        const beforeCount = this.companyEntryTargets.length

        Turbo.renderStreamMessage(html)

        setTimeout(() => {
          const afterCount = this.companyEntryTargets.length

          if (afterCount > beforeCount) {
            autocompleteInput.value = ""
          } else {
            autocompleteInput.value = originalInputValue
          }

          this.updateSubmitButtonState()
          this.updateBulkAlertVisibility()
        }, 50)
      })
      .catch((error) => {
        console.error("Error searching for company:", error)
        autocompleteInput.value = originalInputValue
      })
  }

  removeCompany(event) {
    const companyEntry = event.target.closest('[data-leads--companies--add-companies-target="companyEntry"]')
    if (companyEntry) {
      companyEntry.remove()
      this.updateSubmitButtonState()
      this.updateBulkAlertVisibility()
    }
  }

  updateSubmitButtonState() {
    if (this.hasSubmitButtonTarget) {
      const entries = document.querySelectorAll('[data-leads--companies--add-companies-target="companyEntry"]')
      const hasCompanies = entries.length > 0

      this.submitButtonTarget.disabled = !hasCompanies

      if (hasCompanies) {
        this.submitButtonTarget.classList.remove("h-button--disabled")
      } else {
        this.submitButtonTarget.classList.add("h-button--disabled")
      }
    }
  }

  updateBulkAlertVisibility() {
    if (this.hasBulkAlertTarget) {
      const entries = document.querySelectorAll('[data-leads--companies--add-companies-target="companyEntry"]')
      const shouldShowBulkAlert = entries.length >= 4

      if (shouldShowBulkAlert) {
        this.bulkAlertTarget.classList.remove("d-none")
      } else {
        this.bulkAlertTarget.classList.add("d-none")
      }
    }
  }
}
